import type { DataGridFilterState, DataGridSortingState } from '@ibsys/kit';
import type {
  ExpertReportFeedbackFilters,
  ExpertReportFeedbackSortBy,
  ExpertReportFeedbackTarget,
} from '@/entities/expert-report';
import { FEEDBACK_COLUMNS } from './constants';

/** Колонки, по которым список упорядочивается на сервере */
const SORTABLE_COLUMNS: Record<string, ExpertReportFeedbackSortBy> = {
  [FEEDBACK_COLUMNS.changedAt]: 'changedAt',
  [FEEDBACK_COLUMNS.author]: 'authorName',
  [FEEDBACK_COLUMNS.expertReport]: 'expertReportName',
  [FEEDBACK_COLUMNS.target]: 'blockName',
  [FEEDBACK_COLUMNS.version]: 'version',
};

/** Переводит отбор и порядок колонок в условия запроса списка правок. */
export const toFeedbackFilters = (
  filters: DataGridFilterState,
  sorting: DataGridSortingState,
): ExpertReportFeedbackFilters => {
  const period = filters[FEEDBACK_COLUMNS.changedAt] as { from?: string; to?: string } | undefined;
  const activeSort = sorting[0];
  const sortBy = activeSort ? SORTABLE_COLUMNS[activeSort.columnId] : undefined;

  return {
    expertReportId: (filters[FEEDBACK_COLUMNS.expertReport] as number | undefined) ?? undefined,
    authorId: (filters[FEEDBACK_COLUMNS.author] as number | undefined) ?? undefined,
    changedFrom: period?.from || undefined,
    changedTo: period?.to || undefined,
    target: (filters[FEEDBACK_COLUMNS.target] as ExpertReportFeedbackTarget | undefined) ?? undefined,
    sortBy,
    sortOrder: sortBy ? activeSort.direction : undefined,
  };
};
